import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstIn1: [],
		in1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {},
	mutations: {
		set(state, in1) {
			state.in1 = in1
			if (in1) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.in1 = null
		},
		setParamsDataTable(state, payload) {
			state.lstIn1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, in1insumo) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Stock/RawMaterial/Find/${in1insumo}`)
				.then(response => {
					let in1 = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", in1)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			store.state.loading = false
		},
		async findByAnalysisSubclass(store, subclass){
			store.state.loading = true
			store.commit("initForm")

			try {
				const response = await this._vm.$axios.get(`/Stock/RawMaterial/FindListByAnalysisSubclass/${subclass}`)
				const lstIn1 = Utils.ValidateAxiosResponse(response.data)
				return lstIn1
			}
			catch (error) {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			}
			finally {
				store.state.loading = false
			}
		},
		save(store){
			if (store.state.in1.in1insumo){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.post("/Stock/RawMaterial/Insert", store.state.in1)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/insumos")
					store.state.in1 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Stock/RawMaterial/Update", store.state.in1)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/insumos")
					store.state.in1 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Stock/RawMaterial/Delete/${store.state.in1.in1insumo}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/insumos")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Stock/RawMaterial/FindList")
				.then(response => {
					let lstIn1 = Utils.ValidateAxiosResponse(response.data)
					store.state.lstIn1 = lstIn1
					store.state.hasNext = lstIn1.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstIn1 = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Stock/RawMaterial/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstIn1 = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
			return payload
		},

		async findByCode(store, { in1insumo, ignoreErrorDialog = false }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Consultando insumos", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.get(`/Stock/RawMaterial/FindByCode/${in1insumo}`)
				.then(response => {
					let in1 = Utils.ValidateAxiosResponse(response.data)
					return in1
				})
			.catch((error) => {
				if(!ignoreErrorDialog) {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return null
				}
			});
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async getAllRecipientsPrioritizedByRelationship({ dispatch }, { in1insumo, text, fieldsToReturn = [] }) {
			try {
				const response = await this._vm.$axios.get("/Stock/RawMaterial/GetAllRecipientsPrioritizedByRelationship", {
					params: { in1insumo, search: text },
				})

				const data = Utils.ValidateAxiosResponse(response.data)
				return Utils.PickProps(data, fieldsToReturn)
			} catch (error) {
				await dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return null
			}
		},
		async findCylinderFullInfo(store, { in1insumo = "", ignoreErrorDialog = false }){
			store.state.loading = true
			return await this._vm.$axios.get(`/Stock/RawMaterial/FindCylinderFullInfo/${in1insumo}`)
			.then(response => {
				store.state.loading = false
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				if (!ignoreErrorDialog) {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				}
			});
		},
		async findRawMaterialFullInfo(store, in1insumo){
			store.state.loading = true
			return await this._vm.$axios.get(`/Stock/RawMaterial/FindRawMaterialFullInfo/${in1insumo}`)
			.then(response => {
				store.state.loading = false
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
		},

		async physicalBalance(store, me2) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Consultando estoque do insumo", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.get(
					`/Stock/RawMaterial/PhysicalBalance?me2insumo=${me2.me2insumo}&me2cor=${me2.me2cor}&me2tamanho=${me2.me2tamanho}&me2lote=${me2.me2lote}&me2almox=${me2.me2almox}&me2ender=${me2.me2ender}&me2volume=${me2.me2volume}`,
				)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return 0
				})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })

			return payload
		},
	},
}
